import { compact } from 'lodash';

import { EMPTY_CONTENT_HYPHEN } from '@/components/typography/placeholders';

import { ClientProfileSummaryPanel_ClientProfileFragment } from './graphql/ClientProfileSummaryPanel.generated';

export function getSummaryFields(
  clientProfile?: ClientProfileSummaryPanel_ClientProfileFragment
) {
  const location = clientProfile?.address?.cityName
    ? compact([
        clientProfile?.address?.cityName,
        clientProfile?.address?.stateCode,
      ]).join(', ')
    : EMPTY_CONTENT_HYPHEN;

  const fields = {
    title: clientProfile?.displayName || EMPTY_CONTENT_HYPHEN,
    legalName: clientProfile?.legalName || EMPTY_CONTENT_HYPHEN,
    email: clientProfile?.email || EMPTY_CONTENT_HYPHEN,
    location: location || EMPTY_CONTENT_HYPHEN,
  } as const;

  return fields;
}
